<template>
  <b-card>
    <h1 class="text-center mb-3">Tabela de Aluguéis</h1>
    <div class="mt-3 rent-info-container">
      <div class="rent-info-box">
        <b-spinner class="loading-charged" v-if="isLoading" variant="primary" small></b-spinner>
        <strong> Aluguel Cobrado: </strong>{{ formatCurrency(rentChargedLocal) }}
      </div>

      <div class="rent-info-box">
        <b-spinner class="loading-paid" v-if="isLoading" variant="primary" small></b-spinner>
        <strong> Aluguel Pago: </strong>{{ formatCurrency(rentPaidLocal) }}
      </div>
    </div>

    <b-form-group label="Selecione o número do EC">
      <div class="d-flex align-items-end justify-content-between">

        <b-form-select
          class="select"
          v-model="selectedKey"
          :options="formattedKeysData"
          @change="applyFilter"
        />

        <b-button
          variant="primary"
          class="export-btn"
          @click="exportToExcel"
        >
          Exportar Excel
        </b-button>
      </div>
    </b-form-group>

    <b-table
      v-if="localFilteredRentData && localFilteredRentData.length > 0"
      :fields="tableFields"
      :items="filteredByEc || localFilteredRentData"
      :per-page="itemsPerPage"
      :current-page="currentPage"
      striped
      hover
      responsive
      class="text-center"
    >
      <template v-slot:cell(date)="row">
        {{ formatDate(row.item.date) }}
      </template>
      <template v-slot:cell(amount)="row">
        {{ formatCurrency(row.item.amount) }}
      </template>
      <template v-slot:cell(fee)="row">
        {{ formatCurrency(row.item.fee) }}
      </template>
      <template v-slot:cell(available)="row">
        {{ formatCurrency(row.item.available) }}
      </template>
      <template v-slot:cell(waitingFunds)="row">
        {{ formatCurrency(row.item.waitingFunds) }}
      </template>
      <template v-slot:cell(balanceAmount)="row">
        {{ formatCurrency(row.item.balanceAmount) }}
      </template>
      <template v-slot:cell(balanceOldAmount)="row">
        {{ formatCurrency(row.item.balanceOldAmount) }}
      </template>
      <template v-slot:cell(netAmount)="row">
        {{ formatCurrency(row.item.netAmount) }}
      </template>
      <template v-slot:cell(paid)="row">
        {{ booleanToString(row.item.paid) }}
      </template>
      <template v-slot:cell(actions)="row">
        <p variant="primary" @click="openModal(row.item.establishmentId)">
          <img class="eye" src="@/assets/images/icons/eye.png" alt="olho" />
        </p>
      </template>
    </b-table>

    <b-pagination
      v-if="localFilteredRentData.length"
      v-model="currentPage"
      :total-rows="localFilteredRentData.length"
      :per-page="itemsPerPage"
      align="center"
      size="md"
      class="mt-3"
    >
    </b-pagination>
    <p v-else class="text-center text-danger">Não há aluguéis para este mês.</p>
    <RentModal
      :showModal="showModal"
      @update:showModal="showModal = $event"
      :establishmentId="establishmentId"
      :formattedDate="formattedDate"
      @changeLoading="changeLoading"
      @updateRentValues="updateRentValues"
      :selectedKey="selectedKey"
    />
  </b-card>
</template>
<script>
import {
  BCard,
  BFormSelect,
  BTable,
  BFormGroup,
  BPagination,
  BButton,
  BSpinner,
} from "bootstrap-vue";
import "font-awesome/css/font-awesome.css";
import RentValidator from "./RentValidator";
import RentModal from "./RentModal.vue";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";


export default {
  props: {
    rentData: { type: Array, default: () => [] },
    rentCharged: { type: Number, default: 0 },
    rentPaid: { type: Number, default: 0 },
    keysData: { type: Array, default: () => [] },
    filteredRentData: { type: Array, default: () => [] },
    formattedDate: { type: String, default: null },
  },
  components: {
    BCard,
    BFormSelect,
    BTable,
    BFormGroup,
    BPagination,
    BButton,
    BSpinner,
    RentValidator,
    RentModal,
  },
  data() {
    return {
      selectedKey: null,
      rentChargedLocal: 0,
      rentPaidLocal: 0,
      isLoading: false,
      rentChargedBackup: 0,
      rentPaidBackup: 0,
      rentChargedEc: null,
      rentPaidEc: null,
      currentPage: 1,
      itemsPerPage: 8,
      loading: false,
      showModal: false,
      establishmentId: null,
      localFilteredRentData: this.filteredRentData,
      filteredByEc: undefined,
      tableFields: [
        { key: "actions", label: "" },
        { key: "establishmentId", label: "EC" },
        { key: "name", label: "Nome" },
        { key: "paid", label: "Pago" },
        { key: "balanceId", label: "ID do balanço" },
        { key: "type", label: "Tipo" },
        { key: "description", label: "Descrição" },
        { key: "date", label: "Data" },
        { key: "available", label: "Disponível" },
        { key: "waitingFunds", label: "Aguardando Fundos" },
        { key: "balanceOldAmount", label: "Saldo Anterior" },
        { key: "amount", label: "Valor" },
        { key: "fee", label: "Taxa" },
        { key: "netAmount", label: "Valor Líquido" },
        { key: "balanceAmount", label: "Saldo Atual" },
      ],
    };
  },
  computed: {
    formattedKeysData() {
      return [
        { value: null, text: "----------------------------------" },
        ...this.keysData.map((key) => ({
          value: key,
          text: `EC ${key}`,
        })),
      ];
    },
  },

  watch: {
    filteredRentData(newVal) {
      this.localFilteredRentData = newVal;
    },
    rentCharged(newVal) {
      this.rentChargedLocal = newVal;
    },
    rentPaid(newVal) {
      this.rentPaidLocal = newVal;
    },
  },
  methods: {
    formatDate(date) {
      if (!date) return "";
      return new Date(date).toLocaleDateString("pt-BR", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });
    },


async exportToExcel() {
  const data =
    this.filteredByEc && this.filteredByEc.length
      ? this.filteredByEc
      : this.localFilteredRentData;

if (!data || !data.length) {
  this.$bvToast.toast("Não há dados para exportar.", {
    title: "Aviso",
    variant: "warning",
    solid: true,
    autoHideDelay: 4000,
    toaster: "b-toaster-top-right",
  });
  return;
}

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Aluguéis");
  worksheet.mergeCells("A1:N1");
  worksheet.getCell("A1").value = "Tabela de Aluguéis";
  worksheet.getCell("A1").font = { bold: true, size: 16 };
  worksheet.getCell("A1").alignment = { horizontal: "center" };

worksheet.getCell("A3").value = "Aluguel Cobrado";
worksheet.getCell("B3").value = this.rentChargedLocal;

worksheet.getCell("A4").value = "Aluguel Pago";
worksheet.getCell("B4").value = this.rentPaidLocal;

["B3", "B4"].forEach(cell => {
  worksheet.getCell(cell).numFmt = '"R$"#,##0.00';
});

["A3", "B3", "A4", "B4"].forEach(ref => {
  const cell = worksheet.getCell(ref);
  cell.font = { bold: true };
  cell.alignment = { horizontal: "center", vertical: "middle" };
  cell.border = {
    top: { style: "thin" },
    left: { style: "thin" },
    bottom: { style: "thin" },
    right: { style: "thin" },
  };
});

worksheet.addRow([]);
  const headerRow = worksheet.addRow([
    "EC",
    "Nome",
    "Pago",
    "ID do Balanço",
    "Tipo",
    "Descrição",
    "Data",
    "Disponível",
    "Aguardando Fundos",
    "Saldo Anterior",
    "Valor",
    "Taxa",
    "Valor Líquido",
    "Saldo Atual",
  ]);

headerRow.eachCell(cell => {
  cell.fill = {
    type: "pattern",
    pattern: "solid",
    fgColor: { argb: "2C2E65" },
  };
  cell.font = { bold: true, color: { argb: "FFFFFF" } };
  cell.alignment = { horizontal: "center", vertical: "middle" };
  cell.border = {
    top: { style: "thin" },
    left: { style: "thin" },
    bottom: { style: "thin" },
    right: { style: "thin" },
  };
});


  data.forEach(item => {
    const row = worksheet.addRow([
      item.establishmentId,
      item.name,
      this.booleanToString(item.paid),
      item.balanceId,
      item.type,
      item.description,
      this.formatDate(item.date),
      item.available,
      item.waitingFunds,
      item.balanceOldAmount,
      item.amount,
      item.fee,
      item.netAmount,
      item.balanceAmount,
    ]);

row.eachCell(cell => {
  cell.alignment = {
    horizontal: "center",
    vertical: "middle",
  };
  cell.border = {
    top: { style: "thin" },
    left: { style: "thin" },
    bottom: { style: "thin" },
    right: { style: "thin" },
  };
});

  });

  ["H", "I", "J", "K", "L", "M", "N"].forEach(col => {
    worksheet.getColumn(col).numFmt = '"R$"#,##0.00';
  });

  worksheet.columns.forEach(col => {
    col.width = 22;
  });

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type:
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  saveAs(blob, `alugueis_${new Date().toISOString().slice(0, 10)}.xlsx`);
},



    formatCurrency(value) {
      if (value === null || value === undefined) return "R$ 0,00";
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(value);
    },
    booleanToString(value) {
      return value ? "SIM" : "NÃO";
    },
    updateRentValues(rentPaidEc) {
      this.rentPaidLocal = rentPaidEc.rentPaidEc;
      this.rentChargedLocal = rentPaidEc.rentChargedEc;
    },
    changeLoading() {
      this.isLoading = false;
    },
    applyFilter() {
      if (this.selectedKey) {
        this.isLoading = true;
        this.rentChargedBackup = this.rentCharged;
        this.rentPaidBackup = this.rentPaid;
        const filteredEc = [];
        const filtered = this.localFilteredRentData.filter(
          (item) => item.establishmentId == this.selectedKey
        );
        filteredEc.push(...filtered);
        this.filteredByEc = filteredEc;
        this.establishmentId = filtered[0] ? filtered[0].establishmentId : null;
      } else {
        this.ClearEc();
        this.localFilteredRentData = [...this.rentData];
        this.rentChargedLocal = this.rentChargedBackup;
        this.rentPaidLocal = this.rentPaidBackup;
      }
    },
    ClearEc() {
      this.selectedKey = null;
      this.filteredByEc = undefined;
      this.localFilteredRentData = [...this.rentData];
    },
    openModal(establishmentId) {
      this.establishmentId = establishmentId;
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
  },
};
</script>
<style scoped >
.rent-info-container {
  display: flex;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 20px;
}
.rent-info-box {
  background-color: #f1f1f1;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  flex: 1;
  text-align: center;
  font-size: 1.1rem;
  font-weight: bold;
  color: #333;
  position: relative;
}
.loading-charged {
  position: absolute;
  top: 30%;
  left: 25%;
  height: 20px;
  width: 20px;
}
.loading-paid {
  position: absolute;
  top: 30%;
  left: 29%;
  height: 20px;
  width: 20px;
}
.select {
  width: 49%;
}
.eye {
  width: 25px;
}
</style>
